import { useMemo } from "react";
import cn from "classnames";
import { useExceptionsQuery } from "entities/SeaExceptions";
import { SeaSearchCardModel } from "entities/SeaSearchCard";
import { Nullable } from "shared/lib/typeCheck.lib";
import { useTranslation } from "shared/localization/localization";
import { Link } from "shared/ui/Button";
import { ArrowDown1Icon } from "shared/ui/Icons";
import { Preloader } from "shared/ui/Preloader";
import { DateFormatList, formatDate } from "shared/utils/dateTime.utils";
import { PRICING_PAGE_TRACKING_SYSTEM_URL } from "shared/utils/url.utils";
import s from "./Exceptions.module.scss";

import { transformDescription } from "../../model/utils";

type ExceptionsProps = {
  data: Nullable<SeaSearchCardModel>;
};

export const Exceptions: RFC<ExceptionsProps> = ({ data }) => {
  const { t } = useTranslation();

  const isFreeSubscription = useMemo(() => data?.subscription?.isFree, [data?.rawData]);

  const { exceptionsResponse, isExceptionsLoading } = useExceptionsQuery({
    params: {
      sealine: data?.getCarrierScac() ?? null,
      type: data?.referenceType ?? null,
      number: data?.reference ?? "",
    },
    shouldRequestOnMount: !isFreeSubscription,
  });

  if (isFreeSubscription) {
    return (
      <div className={s.freeSubscriptionExceptionsWrapper}>
        <div className={s.freeSubscriptionText}>
          {t("Please upgrade your subscription to see Exceptions for your shipment")}
        </div>

        {/* <Link
          variant="primary"
          size="medium"
          className={s.upgradeBtn}
          href={PRICING_PAGE_TRACKING_SYSTEM_URL}
          target="_blank"
        >
          {t("Upgrade")}
        </Link> */}
      </div>
    );
  }

  return (
    <div className={s.exceptionsWrapper}>
      {isExceptionsLoading && <Preloader />}
      {exceptionsResponse?.exceptions?.length ? (
        <ul className={s.list}>
          {exceptionsResponse.exceptions.map((exception, i) => {
            const dates = transformDescription(exception.description);

            return (
              <li className={s.item} key={`${i}-${exception?.date}`}>
                <div className={s.nameBox}>
                  <span className={s.name}>{exception.name}</span>
                  <span className={s.date}>{formatDate(exception.date, { format: DateFormatList.DATE_TIME_AM })}</span>
                </div>
                {!!dates?.length && (
                  <span className={s.description}>
                    {dates[0] && (
                      <span className={cn(s.descriptionDate, s.dateFrom)}>
                        {formatDate(dates[0], { format: DateFormatList.CARD_BASE })}
                      </span>
                    )}
                    {dates[1] && <ArrowDown1Icon />}
                    {dates[1] && (
                      <span
                        className={cn(s.descriptionDate, s.dateTo, exception.hasNegativeChange && s.negativeChange)}
                      >
                        {formatDate(dates[1], { format: DateFormatList.CARD_BASE })}
                      </span>
                    )}
                  </span>
                )}
              </li>
            );
          })}
        </ul>
      ) : (
        <div className={s.errorWrapper}>
          <div className={s.notAvailableBold}>{t("No exceptions on this shipment")}</div>
        </div>
      )}
    </div>
  );
};
